export default class StyledHelper {
  static sfw = (...propList) => {
    return {
      shouldForwardProp: (prop) => {
        let propListArr = [];
        for (const element of propList) {
          if (Array.isArray(element)) {
            propListArr.push(...element);
          } else {
            propListArr.push(element);
          }
        }
        return !propListArr.includes(prop);
      },
    };
  };
}
